import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { SharedService } from 'app/shared/service/shared.service';
import { NavigateRightService } from 'app/shared/service/navigate-rights.service';
import { MenuAccessServiceProxy } from 'shared/service-proxies/services/menu-access.service';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { AuthenticatedUserDto } from 'shared/service-proxies/models/authenticated-user-dto.model';
import { Router } from '@angular/router';

@Component({
    selector: 'fuse-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit {
    profileImage: any;
    userName: any;
    isAdmin: boolean = true;
    isMenuOpen = false;
    currentUser: AuthenticatedUserDto = new AuthenticatedUserDto();

    @Input()
    layout = 'vertical';

    @Input()
    navigation: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _authenticationService: AuthenticationService,
        private _sharedService: SharedService,
        private _menuAccessServiceProxy: MenuAccessServiceProxy,
        private localStorageService: LocalStorageService,
        private _navigateRightService: NavigateRightService,
        private _localStorageService: LocalStorageService,
        private _router: Router,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.localStorageService.getData(LocalStorage.TOKEN))
            this.getRoleWiseWright();
        this.currentUser = this._localStorageService.getData(LocalStorage.CURRENT_USER);
        this.userName = this.currentUser?.fullName;
        this.isAdmin = this._authenticationService.isAdministrator();
        // Load the navigation either from the input or from the service
        this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();

        // Subscribe to the current navigation changes
        this._fuseNavigationService.onNavigationChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Load the navigation
                this.navigation = this._fuseNavigationService.getCurrentNavigation();

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        // Subscribe to navigation item
        merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    get GetprofileImage() {
        this.profileImage = this._localStorageService.getData(LocalStorage.PROFILE)
        return this.profileImage;
    }

    changeuser() {
        this._sharedService.changeUsernamePopup(true);
        this._changeDetectorRef.detectChanges();
    }
    changePass() {
        this._sharedService.changePasswordPopup(true);
        this._changeDetectorRef.detectChanges();
    }

    onLogout() {
        this._sharedService.UserLogout();
    }

    menuOpened() {
        this.isMenuOpen = true;
    }

    menuClosed() {
        this.isMenuOpen = false;
    }


    async getRoleWiseWright() {
        let roleId = this._authenticationService.CurrentUserRoleId();
        const myPromise = new Promise((resolve, reject) => {
            this._menuAccessServiceProxy.getRolewiseMenuWrightsAssign(roleId).subscribe(response => {
                if (response.isSuccess) {
                    this._sharedService.menuAccessWright = response.responseData;
                    this.navigation.forEach(parent => {
                        // Hide Attendance menu for Admin.
                        if (parent.title == 'Attendance' && this.isAdmin) {
                            parent.hidden = true;
                        }
                        else {
                            parent.hidden = !this._navigateRightService.canViewParent(parent.id);
                        }
                        if (parent.children)
                            parent.children.forEach(menu => {
                                menu.hidden = !this._navigateRightService.canView(menu.id);
                            });
                    });
                    this._changeDetectorRef.detectChanges();
                    resolve(response);
                }
            })
        });
        await myPromise;
    }

    myprofile() {
        this._router.navigate(['my-profile']);
    }
}
